import React, { Component } from 'react';
import { connect } from 'react-redux';
import { enrollCreateAccount } from '../modules/enroll_actions';

class EnrollCreateAccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShowing:       true,
      customer: {}
    };
    this.toggleShowingState = this.toggleShowingState.bind(this);
  }

  handleChange( sLabel, sObjectType, event ) {
    let oActiveUpdate       = this.state[ sObjectType ];
    oActiveUpdate[ sLabel ] = event.target.value;
    let oUpdate             = {};
    oUpdate[ sObjectType ]  = oActiveUpdate;
    this.setState( oUpdate );
  }

  enrollCustomer( evt ) {
    evt.preventDefault();
    let oState                    = this.state;
    let oaddCustomer              = {};
    oaddCustomer.customer         = oState.customer;
    this.props.dispatch( enrollCreateAccount( oaddCustomer ));
  }

  toggleShowingState() {
    this.setState({isShowing: !this.state.isShowing });
  }

  render() {
    const sPhone = this.props.store.member_services_phone;
    let bookPrice = !this.props.store.bundle_pricing ? this.props.store.one_credit : this.props.store.second_book;
    let titlesType, hundredsOfTitles, amazingSavings;
    let featured = "Featured", percentage = "25%", publisherPrices = "Publishers’ Edition prices",
    Hardcovers = "Hardcovers", books = "books";
    switch(this.props.store.tla){
        case "TGC":
            titlesType = "cooking";
            hundredsOfTitles = "The Club has a vast selection of today's top cookbooks from world-famous chefs, such as Rachael Ray, Paula Deen, Martha Stewart, Emeril Lagasse and more.";
            amazingSavings = "With our unbeatable deals, you'll experience great discounts on all the books you need to create mouth-watering meals. Remember, you'll always save up to 25% off Publishers' Edition prices."
            break;
        case "MIL":
            titlesType = "military";
            hundredsOfTitles = "Our Club has a vast selection of today's top military titles covering topics ranging from the Civil War, World War II, and Vietnam to special ops, firearms, survival prep, and more.";
            amazingSavings = "With our unbeatable deals, you’ll experience great discounts on all the books you need to complete your military library. Remember, you’ll always save up to 25% off Publishers’ Edition prices.";
            break;
        case "CRF":
            titlesType = "crafting";
            hundredsOfTitles = "Our Club has a vast selection of today's top titles in coloring, quilting, sewing, crocheting, and more. We have crafts that the whole family can enjoy!";
            amazingSavings = "With our unbeatable deals, you’ll experience great discounts on all the books you need to make craf-tastic creations. Remember, you’ll always save up to 25% off Publishers’ Edition prices.";
            break;
        case "LSC":
            titlesType = "";
            hundredsOfTitles = "Our Club has a vast selection of today’s top science titles covering topics ranging from quantum physics, evolutionary biology, and chemistry to astronomy, computing, and technology!";
            amazingSavings = "With our unbeatable deals, you’ll experience great discounts on all the books you need to explore earth, evolution, and the cosmos. Remember, you’ll always save up to 25% off Publishers’ Edition prices.";
            break;
        case "SPT":
            titlesType = "health and well-being";
            hundredsOfTitles = "Our Club has a vast selection of today’s top mind/body/spirit titles covering topics ranging from yoga, meditation, energy healing and natural remedies to tarot, Wicca, psychic phenomena and much more.";
            amazingSavings = "With our unbeatable deals, you’ll experience great discounts on all the books you need to transform your life. Remember, you’ll always save up to 25% off Publishers’ Edition prices.";
            break;
        case "DLP":
            titlesType = "large print";
            hundredsOfTitles = "Our Club has a vast selection of today’s top large print titles, including bestselling suspense, mysteries, romance, biographies, and more.";
            amazingSavings = "With our unbeatable deals, you’ll experience great discounts on essential and unforgettable books. Remember, you’ll always save up to 25% off Publishers’ Edition prices.";
            break;
        case "DVD":
            featured = "Director's", percentage = "60%", publisherPrices = "regular Club prices",
            titlesType = "movie", books = "DVDs", Hardcovers = "DVDs";
            hundredsOfTitles = "Our Club has a vast selection of today's top titles, from the hottest action to the most gripping drama.";
            amazingSavings = "With our unbeatable deals, you’ll experience great discounts on all the DVDs you need to make a night in perfect. Remember, you’ll always save up to 60% off regular Club prices.";
            break;
    }
    let oMemberBenefits = this.props.store.type === "Neglite" ? (
      <ul className="checklist">
        <li>Discover the best new {books} each month.</li>
        { this.props.store.bundle_pricing ? (<li>{Hardcovers} as low as ${bookPrice} when you bundle and save.</li>) : ( <li>{Hardcovers} as low as {bookPrice} when you purchase with member credits. </li>)}
        <li>Always free shipping on 3 or more {books}.</li>
        <li>No obligation to buy, cancel any time.</li>
        { ['CRS','SFC'].includes(this.props.store.tla) ? '' : <li>Skip your member credits any month.</li> }
      </ul>
    ) : (
      <ul className="checklist">
        <li>Discover the best new {titlesType} titles each month.</li>
        <li>{Hardcovers} at up to {percentage} off {publisherPrices}.</li>
        <li>Always free shipping on orders of 3 or more {books} when the total purchase price is $35 or more.</li>
        <li>Your choice to accept or decline your {featured} Selections.</li>
        <li>No obligation to buy, cancel any time.</li>
      </ul>
    );


    let oHowItWorks = this.props.store.type === "Neglite" ? (
      <div className={"bordered-box" + (this.state.isShowing ? " showing" : " hidden")} >
        <h4 className="alt">How Your Membership Works</h4>
        { ['CRS','SFC'].includes(this.props.store.tla) ? <ul className="list"><li><strong className="highlight-color">Cancel any time.</strong>There is no obligation to buy and you can cancel your membership anytime online or by calling {sPhone}.</li></ul>
        : <ul className="list">
          <li><strong className="highlight-color">Save with member credits.</strong>{'Visit the site between the 1st and the 10th and press "Buy Now" to purchase your Member Credits. Use them right away or save them for later. They never expire!'}</li>
          <li><strong className="highlight-color">Skip any month.</strong>If you don’t want your monthly Member Credits, visit the site and click “SKIP” by the 10th of the month.  If you don’t click “SKIP,” we will automatically purchase your credits for you using your credit card on file.</li>
          <li><strong className="highlight-color">Cancel any time.</strong>There is no obligation to buy and you can cancel your membership anytime online or by calling {sPhone}.</li>
          </ul> }
        <div className="center"><a className="center" onClick={this.toggleShowingState}>See Member Benefits</a></div>
       </div>
    ):(
        <div className={"bordered-box" + (this.state.isShowing ? " showing" : " hidden")} >
          <h4 className="alt">How {featured} Selections Work</h4>
          <ul className="list">
            <li><strong className="highlight-color">{featured} Selections</strong>New {featured} Selections are announced every few weeks.</li>
            <li><strong className="highlight-color">Hundreds of Titles</strong>{hundredsOfTitles}</li>
            <li><strong className="highlight-color">Amazing Savings</strong>{amazingSavings}</li>
          </ul>
          <div className="center"><a className="center" onClick={this.toggleShowingState}>See Member Benefits</a></div>
        </div>
      );


    return (
      <div className="info-edit-form showing" >
        <form onSubmit={this.enrollCustomer.bind( this )}>
          <div className="half-col left">
            <h4 className="alt2">Account Information</h4>
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'first_name', 'customer' )}
              placeholder = "First Name"
              value       = {this.state.customer.first_name}
              required    = "required" />
            <input
              type        = "text"
              onChange    = {this.handleChange.bind( this, 'last_name', 'customer' )}
              placeholder = "Last Name"
              value       = {this.state.customer.last_name}
              required    = "required" />
            <input
              type        = "email"
              onChange    = {this.handleChange.bind( this, 'email', 'customer' )}
              placeholder = "Email"
              value       = {this.state.customer.email}
              required    = "required" />
            <input
              type        = "password"
              onChange    = {this.handleChange.bind( this, 'password', 'customer' )}
              placeholder = "Password"
              value       = {this.state.customer.password}
              required    = "required" />

            <div className="bordered-box center">
              <button className="btn-primary fat">Go To Checkout</button>
              <p className="no-margin">Your account will be created when you complete your order.</p>
            </div>

          </div>

          <div className="half-col">
            <div className={"bordered-box" + (this.state.isShowing ? " hidden" : " showing")} >
              <h4 className="alt">Membership Benefits</h4>
              {oMemberBenefits}
              <div className="center"><a className="center" onClick={this.toggleShowingState}>{ this.props.store.type === "Neglite" ? "See how member credits work" : "See how " + featured + " Selections work"}</a></div>
            </div>

            {oHowItWorks}
          </div>
          <div className="full-width">

          </div>
        </form>
      </div>
    );
  }
};



function mapStateToProps(state){
    return {
      'store': state.store,
      'customer': state.customer,
      'storeType' : state.store.type
    };
}

export default connect(mapStateToProps)(EnrollCreateAccount);



// WEBPACK FOOTER //
// ./src/components/EnrollCreateAccount.jsx